<template>
  <div id="manageClass">
    <div class="allBodyDiv">
      <div style="margin-top: 15px; margin-bottom: 15px; overflow: hidden; z-index: 100">
        <div class="fr">
          <el-button id="release" @click="releaseBtn" type="primary"
            >发布考试</el-button
          >
        </div>
      </div>

      <el-tabs v-model="activeTab">
        <el-tab-pane label="未开始" name="notStarted">
          <!-- 未开始 -->
          <el-card class="box-card listCard2 not-started">
              <div v-for="i in notStarted" :key="i.id">
                <div class="testReleaseList">
                  <div class="listHeader">
                    <span
                      style="width: 215px; display: inline-block"
                      class="listHeader-title"
                      >{{ i.group_name }}</span
                    >
                    <el-button
                      style="cursor: default"
                      class="listHeader-btn"
                      type="primary"
                      size="mini"
                      >{{ i.classname }}</el-button
                    >
                    <span class="listHeader-time"
                      >开始时间：{{ i.start_time }}</span
                    >
                    <span class="listHeader-time"
                      >结束时间：{{ i.end_time }}</span
                    >
                    <span class="listHeader-overTime" style="margin-left: 35px"
                      >距离开始：{{ i.startTime }}</span
                    >
                    <el-button
                      @click="handleCancelExam(i)"
                      style="
                        margin-left: 20px;
                        width: 110px;
                        height: 24px;
                        background: rgba(255, 222, 192, 1);
                        border-radius: 12px;
                        color: #ff800e;
                      "
                      class="listHeader-btn"
                      type="primary"
                      size="mini"
                      >撤销发布</el-button
                    >
                  </div>
                  <div class="listBody">
                    <el-table
                      :show-header="false"
                      :data="i.item"
                      border
                      highlight-current-row
                      row-class-name="graspTr"
                      header-row-class-name="graspHeader"
                      style="width: 100%"
                    >
                      <el-table-column
                        label="实验名"
                        width="355"
                        align="center"
                      >
                        <template slot-scope="props">
                          <span
                            @click="
                              $router.push({
                                path: '/testdetails',
                                query: {
                                  plan: props.row.examination_id,
                                  title: i.group_name,
                                  name: props.row.name,
                                  relationId: props.row.relation_id,
                                  classId: i.classId,
                                },
                              })
                            "
                            style="cursor: pointer"
                            >{{ props.row.name }}</span
                          >
                        </template>
                      </el-table-column>

                      <el-table-column label="操作" width="645" align="center">
                        <template slot-scope="props">
                          <div style="display: inline-block; width: 200px">
                            <el-progress
                              :percentage="props.row.ratioHalf"
                              status="success"
                              :show-text="false"
                            ></el-progress>
                          </div>
                          <span>{{ props.row.sub_num }}人</span>/
                          <span>共{{ props.row.studentNum }}人</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>

              <div
                v-if="filters.total > 0"
                style="margin-top: 30px; text-align: right"
              >
                <el-pagination
                  @size-change="pageSizeChange(10)"
                  @current-change="pageChange"
                  :current-page="currentPage4"
                  :page-sizes="[10, 20, 30]"
                  :page-size="filters.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="filters.total"
                ></el-pagination>
              </div>
            </el-card>
        </el-tab-pane>
        <el-tab-pane label="进行中" name="inProgress">
          <!-- 正在进行 -->
          <el-card class="box-card listCard2">
              <div v-for="i in tableData3" :key="i.id">
                <div class="testReleaseList">
                  <div class="listHeader">
                    <span
                      style="width: 215px; display: inline-block"
                      class="listHeader-title"
                      >{{ i.group_name }}</span
                    >
                    <el-button
                      style="cursor: default"
                      class="listHeader-btn"
                      type="primary"
                      size="mini"
                      >{{ i.classname }}</el-button
                    >

                    <span class="listHeader-time"
                      >开始时间：{{ i.start_time }}</span
                    >
                    <span class="listHeader-time"
                      >结束时间：{{ i.end_time }}</span
                    >

                    <span class="listHeader-overTime" style="margin-left: 35px"
                      >距离结束：{{ i.endTime }}</span
                    >
                    <el-button
                      @click="relectUpdo(i.group_id, i.class_id)"
                      style="
                        margin-left: 20px;
                        width: 110px;
                        height: 24px;
                        background: rgba(255, 222, 192, 1);
                        border-radius: 12px;
                        color: #ff800e;
                        display: none;
                      "
                      class="listHeader-btn"
                      type="primary"
                      size="mini"
                      >强制结束</el-button
                    >
                  </div>
                  <div class="listBody">
                    <el-table
                      :show-header="false"
                      :data="i.item"
                      border
                      highlight-current-row
                      row-class-name="graspTr"
                      header-row-class-name="graspHeader"
                      style="width: 100%"
                    >
                      <el-table-column
                        label="实验名"
                        width="355"
                        align="center"
                      >
                        <template slot-scope="props">
                          <span
                            @click="
                              $router.push({
                                path: '/testdetails',
                                query: {
                                  plan: props.row.examination_id,
                                  title: i.group_name,
                                  name: props.row.name,
                                  relationId: props.row.relation_id,
                                  classId: i.classId,
                                },
                              })
                            "
                            style="cursor: pointer"
                            >{{ props.row.name }}</span
                          >
                        </template>
                      </el-table-column>

                      <el-table-column label="操作" width="645" align="center">
                        <template slot-scope="props">
                          <div style="display: inline-block; width: 200px">
                            <el-progress
                              :percentage="props.row.ratioHalf"
                              status="success"
                              :show-text="false"
                            ></el-progress>
                          </div>
                          <span>{{ props.row.sub_num }}人</span>/
                          <span>共{{ props.row.studentNum }}人</span>
                        </template>
                      </el-table-column>

                      <el-table-column label="详情" width="155" align="center">
                        <template slot-scope="props">
                          <el-button
                            @click="
                              $router.push({
                                path: '/testdetails',
                                query: {
                                  plan: props.row.examination_id,
                                  title: i.group_name,
                                  name: props.row.name,
                                  relationId: props.row.relation_id,
                                  classId: i.classId,
                                },
                              })
                            "
                            class="listHeader-btn"
                            type="primary"
                            size="mini"
                            >测验详情</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>

              <div
                v-if="filters.total > 0"
                style="margin-top: 30px; text-align: right"
              >
                <el-pagination
                  @size-change="pageSizeChange(10)"
                  @current-change="pageChange"
                  :current-page="currentPage4"
                  :page-sizes="[10, 20, 30]"
                  :page-size="filters.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="filters.total"
                ></el-pagination>
              </div>
            </el-card>
        </el-tab-pane>
        <el-tab-pane label="已结束" name="ended">
          <!-- 已结束 -->
          <el-card class="box-card listCard2">
              <div v-for="i in endedExam" :key="i.id">
                <div class="Unpublished">
                  <div class="listHeader">
                    <span
                      style="width: 215px; display: inline-block"
                      class="listHeader-title"
                      >{{ i.group_name }}</span
                    >
                    <el-button
                      style="cursor: default"
                      class="listHeader-btn"
                      type="primary"
                      size="mini"
                      >{{ i.classname }}</el-button
                    >

                    <span class="listHeader-time"
                      >开始时间：{{ i.start_time }}</span
                    >
                    <span class="listHeader-time"
                      >结束时间：{{ i.end_time }}</span
                    >

                    <span class="listHeader-overTime">已结束</span>
                    <a
                      style="float: right; margin-right: 15px"
                      :href="
                        GLOBAL.url.apiPath +
                        '/teachermanager/exercise/exportScore' +
                        '?classId=' +
                        i.classId +
                        '&examId=' +
                        i.examinationId +
                        '&token=' +
                        GLOBAL.userLoginInfo.token
                      "
                    >
                      <el-button size="mini" type="primary">导出成绩</el-button>
                    </a>
                  </div>
                  <!--上线合并断点-->

                  <div class="listBody">
                    <el-table
                      :show-header="false"
                      :data="i.item"
                      border
                      highlight-current-row
                      row-class-name="graspTr"
                      header-row-class-name="graspHeader"
                      style="width: 100%"
                    >
                      <el-table-column
                        width="355"
                        label="实验名"
                        align="center"
                      >
                        <template slot-scope="props">
                          <span
                            @click="
                              $router.push({
                                path: '/testdetails',
                                query: {
                                  plan: props.row.examination_id,
                                  title: i.group_name,
                                  name: props.row.name,
                                  relationId: props.row.relation_id,
                                  classId: i.classId,
                                },
                              })
                            "
                            style="cursor: pointer"
                            >{{ props.row.name }}</span
                          >
                        </template>
                      </el-table-column>

                      <el-table-column label="操作" align="center">
                        <template slot-scope="props">
                          <div style="display: inline-block; width: 200px">
                            <el-progress
                              :percentage="props.row.ratioHalf"
                              status="success"
                              :show-text="false"
                            ></el-progress>
                          </div>
                          <span>{{ props.row.sub_num }}人</span>/
                          <span>共{{ props.row.studentNum }}人</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="详情" width="155" align="center">
                        <template slot-scope="props">
                          <el-button
                            @click="
                              $router.push({
                                path: '/testdetails',
                                query: {
                                  plan: props.row.examination_id,
                                  title: i.group_name,
                                  name: props.row.name,
                                  relationId: props.row.relation_id,
                                  classId: i.classId,
                                },
                              })
                            "
                            class="listHeader-btn"
                            type="primary"
                            size="mini"
                            >考试详情</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>

              <div
                v-if="filters.total > 0"
                style="margin-top: 30px; text-align: right"
              >
                <el-pagination
                  @size-change="pageSizeChange2(10)"
                  @current-change="pageChange2"
                  :current-page="currentPage4"
                  :page-sizes="[10, 20, 30]"
                  :page-size="endedExamPagination.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="endedExamPagination.total"
                ></el-pagination>
              </div>
            </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--发布实验-->
    <el-dialog
      title
      :show-close="false"
      :visible.sync="releaseTest"
      custom-class="testDialog"
      width="1092px"
    >
      <div>
        <el-card class="box-card" style="position: relative; border: none">
          <div slot="header" class="clearfix">
            <i class="blueI"></i>
            <span class="cardHeader">选择实验</span>
            <span class="fr" style="color: #ff912f; font-size: 14px"
              >已选择{{ textNum }}个实验</span
            >
          </div>
          <div class="cardCheck">
            <div id="testCheck">
              <el-checkbox-group
                v-model="releaseForm.checkedTest"
                @change="
                  textNum = releaseForm.checkedTest.length;
                  testNameAdd();
                "
              >
                <el-checkbox
                  v-for="(i, index) in testList"
                  :key="i.experiment_id"
                  :label="i"
                  @change="i.isSelect = !i.isSelect"
                >
                  <div class="checkDiv">
                    <div :title="i.name" class="checkName">
                      {{ index + 1 }}.{{ i.name }}
                    </div>

                    <el-select
                      placeholder="请选择考试时间"
                      v-model="i.selectValue"
                      :disabled="!i.isSelect"
                    >
                      <el-option
                        v-for="item in testTime"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                        <span style="float: left">{{ item.label }}</span>
                      </el-option>
                    </el-select>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="releaseBody" style="margin-top: 20px">
            <el-form
              :model="releaseForm"
              :rules="rulesRelease"
              ref="releaseForm"
              class="demo-ruleForm"
            >
              <el-form-item
                label="是否随机"
                label-width="110px"
                style="display: inline-block"
              >
                <el-radio-group v-model="releaseForm.isRandom">
                  <el-radio :label="false">不随机</el-radio>
                  <el-radio :label="true">随机</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="考试实验个数"
                prop="randomList"
                label-width="110px"
                style="
                  display: inline-block;
                  margin-left: 14px;
                  margin-bottom: 0px;
                  position: relative;
                  top: 15px;
                "
                v-if="
                  releaseForm.isRandom && releaseForm.checkedTest.length > 1
                "
              >
                <el-select
                  v-model="releaseForm.randomList"
                  placeholder="请选择"
                  style="float: left"
                >
                  <div
                    v-for="(i, index) in releaseForm.checkedTest"
                    :key="i.experiment_id"
                  >
                    <el-option
                      :label="index + 1 + '个'"
                      :value="index + 1"
                      v-if="index < releaseForm.checkedTest.length - 1"
                    ></el-option>
                  </div>
                </el-select>
              </el-form-item>

              <el-form-item label="考试名称" prop="name" label-width="110px">
                <el-input
                  style="width: 280px"
                  v-model="releaseForm.name"
                  placeholder="实验名称最多十五个字"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="考试起始时间"
                prop="startTime"
                label-width="110px"
              >
                <el-date-picker
                  v-model="releaseForm.startTime"
                  type="datetime"
                  placeholder="选择开始日期时间"
                  id="beginTime"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item
                label="考试结束时间"
                prop="endTime"
                label-width="110px"
              >
                <el-date-picker
                  v-model="releaseForm.endTime"
                  type="datetime"
                  placeholder="选择结束日期时间"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item
                label="选择班级"
                prop="checkClass"
                label-width="110px"
                style="width: 100%"
              >
                <!--<el-button type="primary" @click="$refs.tags.newClassF();" class="fl" style="margin:0 15px 0 0">新建班级</el-button>-->
                <div>
                  <el-checkbox-group v-model="releaseForm.checkClass">
                    <el-checkbox
                      v-for="i in classList"
                      :key="i.class_id"
                      :label="i.class_id"
                      >{{ i.classname }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="releaseTest = false">取 消</el-button>
          <el-button type="primary" @click="nextRelease('releaseForm')"
            >下一步</el-button
          >
        </div>
      </span>
    </el-dialog>

    <!--发布实验2-->
    <el-dialog
      title
      :show-close="false"
      :visible.sync="releaseTest2"
      custom-class="testDialog"
      width="680px"
    >
      <div>
        <el-card class="box-card" style="position: relative; border: none">
          <div slot="header" class="clearfix">
            <i class="blueI"></i>
            <span class="cardHeader">确认信息</span>
          </div>
          <div>
            <el-form
              ref="sureReleaseForm"
              class="demo-ruleForm"
              label-width="90px"
            >
              <el-form-item label="考试名称" prop="name">
                <span>{{ releaseForm.name }}</span>
              </el-form-item>
              <el-form-item label="考试班级" prop="checkClass">
                <span>{{ classSelected }}</span>
              </el-form-item>
              <el-form-item label="开始时间" prop="startTime">
                <span>{{ timeArrray[0] }}</span>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime">
                <span>{{ timeArrray[1] }}</span>
              </el-form-item>

              <el-form-item label="考试实验" prop="checkClass">
                <div>
                  <el-table
                    :data="releaseArray"
                    :show-header="false"
                    style="width: 100%"
                  >
                    <el-table-column prop="name"></el-table-column>
                    <el-table-column prop="exam_timelength"></el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button
            @click="
              releaseTest = true;
              releaseTest2 = false;
            "
            >上一步</el-button
          >
          <el-button
            type="primary"
            :loading="releaseLoading"
            @click="releaseTestConfirm()"
            >发 布</el-button
          >
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="撤销发布"
      :visible.sync="releaseUndo"
      custom-class="nbDialog"
      width="500px"
    >
      <div style="width: 375px; margin: auto">
        <div style="font-size: 18px; margin-bottom: 15px">
          您确认要撤销发布实验吗？
        </div>
        <span style="font-size: 14px; color: #b5b5b5"
          >实验撤销后，已完成的实验数据也将全部清除且无法找回！</span
        >
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="releaseUndo = false">取 消</el-button>
          <el-button type="primary" @click="undoGroup">确 定</el-button>
        </div>
      </span>
    </el-dialog>

    <!--无学生加入成功-->
    <el-dialog
      title="发布成功"
      :visible.sync="succerTest"
      custom-class="nbDialog"
      width="500px"
    >
      <div v-if="classUserNum <= 0">
        <div>
          <span
            style="
              text-align: left;
              font-size: 16px;
              display: inline-block;
              margin-bottom: 15px;
            "
            >您的考试已经发布成功，您可在“班级管理”对应的班级中，看到您发布的考试被完成情况</span
          >
          <span>您可以通过以下方式邀请学生参与您发布的实验考试</span>
        </div>
        <div class="joinNum">
          <span>班级编号：</span>
          <span>{{ classInfo.classCode }}</span>
        </div>
        <div class="joinText">
          <div>
            <i>1</i>
            <span
              >将“班级编号：{{
                classInfo.classCode
              }}”写在黑板上或发送给需要加入的学生</span
            >
          </div>
          <div>
            <i>2</i>
            <span
              >让学生使用电脑访问网址并使用给定的帐号密码登录：{{
                examUrl
              }}</span
            >
          </div>
          <div>
            <i>3</i>
            <span
              >让学生点击右上角的“个人中心”按钮，进入后填写班级编号，搜索班级加入</span
            >
          </div>
        </div>
      </div>
      <div v-else style="width: 300px; margin: auto">
        您的实验已经发布成功，您可在'考试中心'中，看到您发布的实验被完成的情况
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="succerTest = false">知道了</el-button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="noClass"
      custom-class="nbDialog"
      width="300px"
    >
      <div>您名下暂无班级，请到班级管理里创建班级！</div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="noClass = false">知道了</el-button>
        </div>
      </span>
    </el-dialog>

    <div id="examData">
      <nb-tags ref="tags" v-on:child-data="getChildData"></nb-tags>
    </div>
  </div>
</template>
<script>
import {
  getpushlist,
  getexamlist,
  getclasslist,
  pushexam,
  revokepublic,
  getexpertestinfo,
  cancelExam,
} from "./../../api/exam_api";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      activeTab: "notStarted",
      noClass: false,
      classUserNum: 0,
      succerTest: false,
      releaseUndo: false,
      tableData3: [],
      endedExam: [],
      notStarted: [], // 未开始的考试

      notStartedPagination: {
        pageSize: 10,
        total: 0,
        page: 1
      },
      filters: {
        pageSize: 10,
        total: 0,
        page: 1,
      }, // 正在进行的的页
      endedExamPagination: {
        pageSize: 10,
        total: 0,
        page: 1,
      }, // 已完成的页
      currentPage4: 1,
      releaseTest: false,
      releaseTest2: false,
      textNum: 0,
      releaseForm: {
        checkedTest: [],
        name: "",
        time: "",
        checkClass: [],
        isRandom: false, // 是否随机
        startTime: "",
        endTime: "",
        randomList: [],
        selectValue: "", // 考试时间
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000;
        }
      },
      testList: [],
      rulesRelease: {
        name: [
          {
            required: true,
            min: 2,
            max: 15,
            message: "请输入2到15位考试名称",
            trigger: "blur",
          },
        ],
        startTime: [
          { required: true, message: "请选择起止时间", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
        checkClass: [
          { required: true, message: "请选择班级", trigger: "blur" },
        ],
        randomList: [
          { required: true, message: "请选择随机实验个数", trigger: "change" },
        ],
      },
      classData: [],
      timeArrray: [],
      classSelected: "",
      releaseArray: [],
      releaseLoading: false,
      classList: [],
      testType: -1,
      groupId: "",
      classId: "",
      classInfo: {},
      examUrl: "",
      isOver: false, // 考试是否结束
      overT: true,
      overF: false,
      testTime: [
        {
          value: "10分钟",
          label: "10分钟",
        },
        {
          value: "20分钟",
          label: "20分钟",
        },
        {
          value: "30分钟",
          label: "30分钟",
        },
      ],
      randomNum: [{ label: "1" }, {}],
      testNameAry: [], // 已经选择的实验名称数组
      testName: "",
    };
  },
  methods: {
    //撤销
    relectUpdo(groupId, classId) {
      this.releaseUndo = true;
      this.groupId = groupId;
      this.classId = classId;
    },
    // 撤销/删除考试
    handleCancelExam(examInfo) {
      this.$confirm("此操作将永久删除该考试，是否继续？", "取消考试", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        cancelExam({
          classId: examInfo.class_id,
          id: examInfo.examinationId
        }).then(res => {
          this.getList();
        });
      });
    },
    undoGroup() {
      revokepublic({ group_id: this.groupId, class_id: this.classId }).then(
        (res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.releaseUndo = false;
            this.getList();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        }
      );
    },
    getChildData() {
      getclasslist().then((res) => {
        if (res.code == 200) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].class_id = res.data[i].class_id.toString();
          }
          this.classList = res.data;
        }
      });
    },
    pageSizeChange(val) {
      this.filters.pageSize = val;
      this.getList();
    }, // 正在进行
    pageChange(val) {
      this.filters.page = val;
      this.getList();
    }, // 正在进行

    pageSizeChange2(val) {
      this.endedExamPagination.pageSize = val;
      this.getList();
    }, // 已完成
    pageChange2(val) {
      this.endedExamPagination.page = val;
      this.getList();
    }, // 已完成

    getList() {
      const loadingInstance = Loading.service({
        target: "#nbBody"
      });
      let inProgressParams = {
        page: this.filters.page,
        perPage: this.filters.pageSize,
        state: 1,
      };
      let endedParams = {
        page: this.endedExamPagination.page,
        perPage: 1000,
        state: 2,
      };
      let notStartParams = {
        page: 0,
        perPage: 20,
        state: 3,
      };
      let that = this;
      Promise.all([getpushlist(notStartParams), getpushlist(inProgressParams), getpushlist(endedParams)]).then(([notStartRes, inProgressRes, endedRes]) => {
        // 未开始的考试
        if (notStartRes.code === 0 && notStartRes.msg === "success") {
          if (notStartRes.data && notStartRes.data.data) {
            this.notStarted = notStartRes.data.data;
            this.notStartedPagination.total = notStartRes.data.total;

            this.notStarted.forEach((exam, idx) => {
              if (exam.examination_info) {
                exam.group_name = exam.examination_info.name;
                exam.classname = exam.class_info.name;
                exam.class_id = exam.classId;
                exam.start_time = that.GLOBAL.request.toTime(exam.examination_info.beginTime * 1000, 1);
                exam.add_time = that.GLOBAL.request.toTime(exam.examination_info.addTime * 1000, 1);
                exam.end_time = that.GLOBAL.request.toTime(exam.examination_info.endTime * 1000, 1);
                
                if (exam.examination_experiment[0]) {
                  // 计算还有多久开始考试
                  let oDate2 = exam.examination_info.beginTime * 1000;
                  let oDate1 = new Date();
                  let nTime = oDate2 - oDate1.getTime();
                  let day = Math.floor(nTime / 86400000);
                  let hour = Math.floor((nTime % 86400000) / 3600000);
                  let minute = Math.floor(
                    ((nTime % 86400000) % 3600000) / 60000
                  );
                  let _time = day + "天 " + hour + "小时 " + minute + "分";
                  exam.startTime = _time;

                  exam.item = exam.examination_experiment;
                  exam.item.forEach(val => {
                    val.ratioHalf = 0;
                    val.studentNum = val.unfinishExam;
                    val.sub_num = val.finishExam;
                    val.examination_id = exam.examination_info.id;
                  });
                }
              } else {
                exam.group_name = "";
              }
            });
          }
        }
        // 进行中的考试
        if (inProgressRes.code == 0) {
          if (inProgressRes.data != []) {
            this.tableData3 = inProgressRes.data.data || [];
            for (let i = 0; i < this.tableData3.length; i++) {
              if (this.tableData3[i].examination_info) {
                this.tableData3[i].group_name =
                  this.tableData3[i].examination_info.name;
              } else {
                this.tableData3[i].group_name = "";
              }
              this.tableData3[i].classname = this.tableData3[i].class_info.name;
              this.tableData3[i].class_id = this.tableData3[i].classId;
            }
            this.filters.total = inProgressRes.data.total;
            this.tableData3.forEach(function (index, i) {
              let _timeNow = new Date().getTime();
              if (index.examination_info != null) {
                index.start_time = that.GLOBAL.request.toTime(
                  index.examination_info.beginTime * 1000,
                  1
                );

                index.add_time = that.GLOBAL.request.toTime(
                  index.examination_info.addTime * 1000,
                  1
                );
                index.end_time = that.GLOBAL.request.toTime(
                  index.examination_info.endTime * 1000,
                  1
                );
              }

              if (index.examination_experiment[0]) {
                let oDate2 = index.examination_info.endTime * 1000;
                let oDate1 = new Date();
                let nTime = oDate2 - oDate1.getTime();
                let day = Math.floor(nTime / 86400000);
                let hour = Math.floor((nTime % 86400000) / 3600000);
                let minute = Math.floor(((nTime % 86400000) % 3600000) / 60000);
                let _time = day + "天 " + hour + "小时 " + minute + "分";
                index.endTime = _time;

                index.item = index.examination_experiment;
                for (let i = 0; i < index.item.length; i++) {
                  index.item[i].ratioHalf =
                    index.item[i].finishExam <= 0
                      ? 0
                      : Math.round(
                          (index.item[i].finishExam /
                            (index.item[i].unfinishExam +
                              index.item[i].finishExam)) *
                            10000
                        ) / 100.0;
                  index.item[i].studentNum =
                    index.item[i].unfinishExam + index.item[i].finishExam;
                  // index.item[i].studentNum = index.class_info.num;

                  index.item[i].sub_num = index.item[i].finishExam;

                  index.item[i].examination_id = index.examination_info.id;
                }
              }
            });
          }
        }
        // 已结束的考试
        if (endedRes.code == 0 && endedRes.msg === "success") {
          if (endedRes.data != [] && endedRes.data.data) {
            this.endedExam = endedRes.data.data;
            this.endedExamPagination.total = endedRes.data.total;
            
            this.endedExam.forEach(exam => {
              if (exam.examination_info) {
                exam.group_name = exam.examination_info.name;
                exam.classname = exam.classInfo ? exam.class_info.name : "";
                exam.class_id = exam.classId;
                exam.start_time = that.GLOBAL.request.toTime(exam.examination_info.beginTime * 1000, 1);
                exam.add_time = that.GLOBAL.request.toTime(exam.examination_info.addTime * 1000, 1);
                exam.end_time = that.GLOBAL.request.toTime(exam.examination_info.endTime * 1000, 1);
              
                if (exam.examination_experiment[0]) {
                  if (exam.examination_experiment[0].finishExam == 0) {
                    let oDate2 = exam.examination_info.beginTime * 1000;
                    let oDate1 = new Date();
                    let nTime = oDate2 - oDate1.getTime();
                    let day = Math.floor(nTime / 86400000);
                    let hour = Math.floor((nTime % 86400000) / 3600000);
                    let minute = Math.floor(((nTime % 86400000) % 3600000) / 60000);
                    let _time = day + "天 " + hour + "小时 " + minute + "分";
                    exam.startTime = _time;
                  }

                  exam.item = exam.examination_experiment;
                  exam.item.forEach(val => {
                    val.ratioHalf = val.finishExam <= 0 ? 0 : Math.round((val.finishExam / (val.finishExam + val.unfinishExam)) * 10000) / 100;
                    val.studentNum = val.unfinishExam + val.finishExam;
                    val.sub_num = val.finishExam;
                    val.examination_id = exam.examination_info.id;
                  });
                }
              } else {
                exam.group_name = "";
              }
            });
          }
        }
        loadingInstance.close();
      })
      getclasslist().then((res) => {
        if (res.code == 200) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].class_id = res.data[i].class_id.toString();
            res.data[i].isSelect = false;
          }
          this.classList = res.data;
        }
      });
    },

    //发布实验
    releaseBtn() {
      this.textNum = 0;
      this.releaseLoading = false;
      this.releaseTest2 = false;
      this.releaseForm = {
        checkedTest: [],
        name: "",
        time: "",
        checkClass: [],
        isRandom: false, // 是否随机
        startTime: "",
        endTime: "",
        randomList: [],
        selectValue: "", // 考试时间
      };
      this.releaseForm.checkClass = [];
      getclasslist().then((res) => {
        if (res.code == 200 || res.code == 0) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].class_id = res.data[i].id.toString();
            res.data[i].classname = res.data[i].name;
          }
          if (res.data.length > 0) {
            this.releaseTest = true;
            this.examList();
          } else {
            this.noClass = true;
          }
          this.classList = res.data;
        }
      });
    },
    //发布实验下一步
    nextRelease(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.releaseForm.endTime < this.releaseForm.startTime || this.releaseForm.endTime < Date.now()) {
            this.$message({
              message: "考试时间不正确",
              type: "error",
            });
            return;
          }
          if (this.releaseForm.checkedTest.length <= 0) {
            this.$message({
              message: "请至少选择一个实验",
              type: "error",
            });
            return;
          } else {
            this.releaseArray = [];
            this.classSelected = "";
            this.classUserNum = 0;
            for (let i = 0; i < this.classList.length; i++) {
              for (let a = 0; a < this.releaseForm.checkClass.length; a++) {
                if (
                  this.classList[i].class_id == this.releaseForm.checkClass[a]
                ) {
                  this.classSelected += this.classList[i].classname + "  ";
                  this.classUserNum += this.classList[i].num;

                  this.classInfo = this.classList[i];

                  // this.examUrl = studentNum.app_url;
                  let _url = window.location.host;
                  this.examUrl = _url;
                }
              }
            }
            for (let i = 0; i < this.testList.length; i++) {
              for (let a = 0; a < this.releaseForm.checkedTest.length; a++) {
                if (
                  this.testList[i].experiment_id ==
                  this.releaseForm.checkedTest[a].experiment_id
                ) {
                  let obj = {
                    name: this.testList[i].name,
                    experiment_id: this.testList[i].experiment_id,
                    exam_timelength: `(实验时长${this.testList[i].selectValue})`,
                    //考试时间
                  };
                  this.releaseArray.push(obj);
                }
              }
            }

            this.timeArrray = [
              this.releaseForm.startTime,
              this.releaseForm.endTime,
            ];
            for (let i = 0; i < this.timeArrray.length; i++) {
              this.timeArrray[i] = this.GLOBAL.request.toTime(
                this.timeArrray[i],
                1
              );
            }
            this.releaseTest = false;
            this.releaseTest2 = true;
          }
        }
      });
    },
    //确定发布实验
    releaseTestConfirm() {
      this.releaseLoading = true;
      let isRank = 0;
      if (this.releaseForm.isRandom) {
        isRank = 1;
      } else {
        isRank = 0;
      }
      let beginTime = this.releaseForm.startTime.getTime() / 1000;
      let endTime = this.releaseForm.endTime.getTime() / 1000;
      for (let j = 0; j < this.releaseForm.checkClass.length; j++) {
        this.releaseForm.checkClass[j] = parseInt(
          this.releaseForm.checkClass[j]
        );
      }
      let data = {
        experimentIds: [],
        isRank: isRank,
        num: this.releaseForm.randomList,
        name: this.releaseForm.name,
        beginTime: beginTime,
        endTime: endTime,
        classIds: this.releaseForm.checkClass,
      };
      for (let i = 0; i < this.releaseForm.checkedTest.length; i++) {
        let obj = {};
        obj.experimentId = this.releaseForm.checkedTest[i].id;
        obj.relation_id = this.releaseForm.checkedTest[i].relation_id;

        obj.timeLength = parseInt(
          this.releaseForm.checkedTest[i].selectValue.split("分")[0]
        );
        data.experimentIds.push(obj);
      }
      pushexam(data).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.textNum = 0;
          this.releaseLoading = false;
          this.releaseTest2 = false;
          this.releaseForm = {
            checkedTest: [],
            name: "",
            time: "",
            checkClass: [],
            isRandom: false, // 是否随机
            startTime: "",
            endTime: "",
            randomList: [],
            selectValue: "", // 考试时间
          };
          this.getList();
          this.succerTest = true;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          this.releaseLoading = false;
        }
      });
    },
    //实验列表
    examList() {
      getexpertestinfo({ packageId: this.GLOBAL.productId }).then((res) => {
        if (res.code == 200) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].experiment_id = res.data[i].id;
            res.data[i].selectValue = "10分钟";
          }
          this.testList = res.data;
          this.selectValue = this.testList.selectValue;
        }
      });
    },
    //返回班级
    backToClass(classId) {
      let cID = document.getElementById("classType");
      let cClass = document.getElementsByClassName("header-nav");
      for (let i = 0; i < cClass.length; i++) {
        cClass[i].classList.remove("activeNav");
      }
      cID.classList.add("activeNav");
      let _url = window.location.host;
      window.location.href = "/#/manageclass?backClass=1&plan=" + classId;
    },
    testNameAdd() {
      this.testNameAry = [];
      for (let i = 0; i < this.releaseForm.checkedTest.length; i++) {
        this.testNameAry.push(this.releaseForm.checkedTest[i].name);
      }
      if (this.testNameAry.length > 1) {
        this.releaseForm.name = this.testNameAry[0] + "等";
      } else {
        this.releaseForm.name = this.testNameAry[0];
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
#examData .manageBody {
  width: 0;
  height: 0;
  overflow: hidden;
}
.el-tabs__nav-scroll {
  background-color: white;
}
.not-started .el-table__body {
  width: 100%!important;
}
.el-checkbox {
  margin-left: 30px;
}
.el-date-picker__time-header {
  position: absolute !important;
  bottom: 5px !important;
  border: none !important;
}
.el-picker-panel__body {
  padding-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/ExaminationCentre.vue